import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Observable, tap } from 'rxjs';
import { Address } from 'src/app/shared/models/address';
import IncidentService from 'src/app/shared/services/incident.service';
import { Incident, IncidentDetailsResponse, IncidentStatus } from '../../incident-models';
import { IncidentCreateOrEditModalComponent } from '../incident-create-or-edit-modal/incident-create-or-edit-modal.component';
import { EnvironmentLoaderService } from '../../../../shared/services/environment-loader.service';
import { IncidentStatusModalComponent } from '../incident-status/incident-status-modal.component';
import { RequiresFeatureRoleDirective } from '../../../../shared/directives/requires-feature-role.directive';
import { IncidentListDetailsComponent } from '../incident-list-details/incident-list-details.component';
import { TranslateIncidentStatusEnumPipe } from '../../../../shared/pipes/translate-incident-status-enum.pipe';
import { FormatIncidentPipe } from '../../../../shared/pipes/format-incident.pipe';
import { TranslateIncidentCategoryEnum } from '../../../../shared/pipes/translate-incident-category-enum.pipe';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'adm-incident-list-expandable',
  templateUrl: './incident-list-expandable.component.html',
  styleUrls: ['./incident-list-expandable.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatChipsModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    RequiresFeatureRoleDirective,
    IncidentListDetailsComponent,
    TranslateIncidentStatusEnumPipe,
    FormatIncidentPipe,
    TranslateIncidentCategoryEnum,
  ],
})
export class IncidentListExpandableComponent {
  private incidentService = inject(IncidentService);
  private dialog = inject(MatDialog);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  @ViewChild(MatExpansionPanel, { static: true }) matExpansionPanel: MatExpansionPanel;

  @Input() incident: Incident;
  @Input() expanded = false;
  public incidentStatus: typeof IncidentStatus = IncidentStatus;

  @Output() update = new EventEmitter();

  public roles = this.environmentLoaderService.virtualRoles;

  loading: boolean;
  incidentDetails$: Observable<IncidentDetailsResponse>;

  incidentStatusEnum = IncidentStatus;

  public get address(): any {
    return new Address(
      this.incident.incidentLocation.city,
      this.incident.incidentLocation.postalCode,
      this.incident.incidentLocation.road,
      this.incident.incidentLocation.number,
      this.incident.incidentLocation.letter
    );
  }

  onEdit() {
    const dialogRef = this.dialog.open(IncidentCreateOrEditModalComponent, {
      data: { isEdit: true, incident: this.incident },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.update.emit();
      }
    });
  }

  changeIncidentStatus() {
    const dialogRef = this.dialog.open(IncidentStatusModalComponent, {
      data: { incident: this.incident },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.update.emit();
      }
    });
  }

  loadIncidentDetails(id: number) {
    this.incidentDetails$ = this.incidentService.getIncidentDetails(id).pipe(
      tap(() => {
        this.loading = false;
      })
    );
  }
}
